<template>
  <view-page
      :baseRoute='baseRoute'
      :entity='entity'
      :button-access="componentAccess"
      :model-entity="modelEntity"
      :page-title="setPageTitle"
  >

    <template v-slot="{ model }">
      <product-form
          v-if="model"
          readonly
          v-model="model"
          card-title="View Product"
      />
    </template>

    <template v-slot:extra-button="{ model }">
      <vs-button
          v-if="model"
          class="mt-2 ml-4"
          color="light"
          @click="openEnableAlert(model)"
      >
        {{ model.IsEnabled ? "Deactivate" : "Activate" }}
      </vs-button>
    </template>
  </view-page>
</template>

<script>

import ProductForm from "@/views/pages/products/ProductForm";
import ViewPage from "@/views/components/Views/ViewPage";
import EnablePublishMixin from '../../../components/mixins/EnablePublishMixin';
import NotificationMixin from '../../../components/mixins/NotificationMixin';

export default {
  name: "ProductDetails",
  components: {
    ProductForm,
    ViewPage,
  },
  mixins: [NotificationMixin, EnablePublishMixin],
  data() {
    return {
      baseRoute: 'products',
      entity: 'Product',
      modelEntity: this.$api.products,
      title: '',
      componentAccess: {
        canEdit: {
          route: 'products.edit',
          access: false,
        },
        canDelete: {
          route: 'products.delete',
          access: false,
        },
      }
    };
  },
  methods: {
    setPageTitle(params) {
      if (!params.ProductCode) {
        return '';
      }

      return "Product: " + params.ProductCode;
    }
  }
};
</script>

<style scoped>

</style>
